// extracted by mini-css-extract-plugin
export var wrap = "BlogPosts-module_wrap__2NvzD";
export var blogsWrapper = "BlogPosts-module_blogsWrapper__22sXr";
export var blogWrapper = "BlogPosts-module_blogWrapper__2EF0C";
export var blog = "BlogPosts-module_blog__2L5zt";
export var blogTitle = "BlogPosts-module_blogTitle__UgRsC";
export var header = "BlogPosts-module_header__27F7Q";
export var wave = "BlogPosts-module_wave__3aeWR";
export var blogImage = "BlogPosts-module_blogImage__1cZSq";
export var headerWrap = "BlogPosts-module_headerWrap__KFt5s";